import { queryClient, apiRequest } from "../lib/queryClient";

const subscriptionKey = "subscription";

export function useSubscription(options = {}) {
  const {
    filters = {},
    sort = { direction: "desc" },
    pagination = { page: 1, limit: 10 },
  } = options;

  const fetchSubscription = async () => {
    const queryParams = new URLSearchParams();
    queryParams.append("page", pagination.page);
    queryParams.append("limit", pagination.limit);
    queryParams.append("sortField", sort.field);
    queryParams.append("sortDirection", sort.direction);
    for (const [key, value] of Object.entries(filters)) {
      queryParams.append(key, value);
    }
    if (filters.status && filters.status !== "all") {
      queryParams.append("status", filters.status);
    }
    if (filters.subscription && filters.subscription !== "all") {
      queryParams.append("subscription", filters.subscription);
    }
    if (filters.search) {
      queryParams.append("search", filters.search);
    }
    const response = await apiRequest(`/admin/subscription?${queryParams.toString()}`, {
      method: "GET",
    });

    return response;
  };

  const createSubscription = async (userData) => {
    const response = await apiRequest("/admin/subscription", {
      method: "POST",
      body: JSON.stringify(userData),
    });
    queryClient.invalidateQueries({ queryKey: [subscriptionKey] });
    return response;
  };

  const updateSubscription = async ({ id, userData }) => {
    const response = await apiRequest(`/admin/subscription/${id}`, {
      method: "PUT",
      body: JSON.stringify(userData),
    });
    queryClient.invalidateQueries({ queryKey: [subscriptionKey] });
    return response;
  };

  const deleteSubscription = async (userId) => {
    await apiRequest(`/admin/subscription/${userId}`, {
      method: "DELETE",
    });
    queryClient.invalidateQueries({ queryKey: [subscriptionKey] });
    return userId;
  };

  const fetchSubscribedUser = async () => {
    const queryParams = new URLSearchParams();
    queryParams.append("page", pagination.page);
    queryParams.append("limit", pagination.limit);
    queryParams.append("sortField", sort.field);
    queryParams.append("sortDirection", sort.direction);
    for (const [key, value] of Object.entries(filters)) {
      queryParams.append(key, value);
    }
    
    if (filters.search) {
      queryParams.append("search", filters.search);
    }
    const response = await apiRequest(`/user/subscribed-user?${queryParams.toString()}`, {
      method: "GET",
    });

    return response;
  };

  return {
    fetchSubscription,
    createSubscription,
    updateSubscription,
    deleteSubscription,
    fetchSubscribedUser
  };
}
